module.exports = __webpack_public_path__ + "img/ic_network_building.632992af.png";